import {Base} from "@/api/Base"

export class PolicyList extends Base {
    path = "policy/list"
}